import { render, staticRenderFns } from "./PayerProperties.vue?vue&type=template&id=3fa947ed&scoped=true"
import script from "./PayerProperties.vue?vue&type=script&lang=js"
export * from "./PayerProperties.vue?vue&type=script&lang=js"
import style0 from "./PayerProperties.vue?vue&type=style&index=0&id=3fa947ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa947ed",
  null
  
)

export default component.exports